/**
 * @module
 * @format
 */

/**
 * @import {Controller} from '@acng/frontend-stargazer';
 */

import {ChangeEventController} from 'nova';
import {guard, IS_INPUT} from '@acng/frontend-rubicon';
import {COMPILE} from '@acng/frontend-stargazer';
import {make} from '../../../core/service/env.js';
import {UserImageUpload} from './upload.js';

/**
 * @implements {Controller}
 */
class UserProfileImageChange extends ChangeEventController {
  /**
   * @param {Element} input
   * @returns {void}
   */
  [COMPILE](input) {
    ASSERT: guard(input, IS_INPUT, '<element>');

    input.type = 'file';
    input.accept = 'image/jpeg,image/png';
    input.multiple = false;
  }

  /**
   * @param {HTMLInputElement} input
   * @returns {void}
   */
  change(input) {
    const file = input.files?.[0];
    const service = make(UserImageUpload);
    service.crop.set(file);
  }
}

export {UserProfileImageChange};
